var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Typography, Grid, MenuItem, Paper, IconButton, Button } from '@mui/material';
import { UploadFile as UploadIcon, PictureAsPdf as PdfIcon, DeleteOutline as DeleteIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import { MODOS, MENSAGENS } from '../../../utils';
import { ROUTES, FUNCIONALIDADES, PAGINAS } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { BotaoSalvar, BotaoFechar, BotaoEditar } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import { getJustificativa, cadastrarJustificativa, alterarJustificativa, abrirAnexoJustificativa, STATUS_API } from './controle_justificativas.service';
var MAX_DETALHADA = 1000;
var TIPOS_PERMITIDOS = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
export var ControleJustificativasEditar = function () {
    var _a = useAuth(), addMensagem = _a.addMensagem, getAcoesFuncionalidade = _a.getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.GF_CONTROLE_JUSTIFICATIVAS); }, [getAcoesFuncionalidade]);
    var navigate = useNavigate();
    var _b = useParams(), id = _b.id, modo = _b.modo;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(true), LoadingInicio = _d[0], setLoadingInicio = _d[1];
    var _e = useState(''), Codigo = _e[0], setCodigo = _e[1];
    var _f = useState(''), Nome = _f[0], setNome = _f[1];
    var _g = useState(''), DescricaoResumida = _g[0], setDescricaoResumida = _g[1];
    var _h = useState(''), DescricaoDetalhada = _h[0], setDescricaoDetalhada = _h[1];
    var _j = useState('Ativo'), Situacao = _j[0], setSituacao = _j[1];
    // Anexo
    var _k = useState(''), AnexoNomeExistente = _k[0], setAnexoNomeExistente = _k[1];
    var _l = useState(null), NovoAnexo = _l[0], setNovoAnexo = _l[1];
    var _m = useState(false), RemoverAnexo = _m[0], setRemoverAnexo = _m[1];
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, getJustificativa(id)];
                case 1:
                    Resp = _g.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == STATUS_API.ERRO) {
                        alert(Resp.Mensagem);
                    }
                    else {
                        setCodigo((_a = Resp.codigo) !== null && _a !== void 0 ? _a : '');
                        setNome((_b = Resp.nome) !== null && _b !== void 0 ? _b : '');
                        setDescricaoResumida((_c = Resp.descricao_resumida) !== null && _c !== void 0 ? _c : '');
                        setDescricaoDetalhada((_d = Resp.descricao_detalhada) !== null && _d !== void 0 ? _d : '');
                        setSituacao((_e = Resp.situacao) !== null && _e !== void 0 ? _e : 'Ativo');
                        setAnexoNomeExistente((_f = Resp.anexo_nome) !== null && _f !== void 0 ? _f : '');
                    }
                    _g.label = 2;
                case 2:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var changeCodigo = function (value) {
        var apenasNumeros = value.replace(/\D/g, '').substring(0, 15);
        setCodigo(apenasNumeros);
    };
    var processarArquivo = function (file) {
        if (file.size > 5 * 1024 * 1024) {
            alert('O arquivo deve ter no máximo 5MB.');
            return;
        }
        if (!TIPOS_PERMITIDOS.includes(file.type)) {
            alert('Formato inválido. São aceitos apenas PDF ou JPG.');
            return;
        }
        var reader = new FileReader();
        reader.onload = function (event) {
            var _a, _b, _c;
            var result = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result) !== null && _b !== void 0 ? _b : '';
            setNovoAnexo({
                nome: file.name,
                base64: (_c = result.split(',')[1]) !== null && _c !== void 0 ? _c : '',
                tipo: file.type,
                tamanho: "".concat((file.size / 1024).toFixed(1), " KB"),
            });
            setRemoverAnexo(false);
        };
        reader.readAsDataURL(file);
    };
    var validarDados = function () {
        if (!Codigo || Codigo.trim() == '') {
            alert("C\u00F3digo Justificativa ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!Nome || Nome.trim() == '') {
            alert("Nome da Justificativa ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var salvarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        codigo: Codigo,
                        nome: Nome,
                        descricao_resumida: DescricaoResumida || null,
                        descricao_detalhada: DescricaoDetalhada || null,
                        situacao: Situacao,
                    };
                    if (NovoAnexo) {
                        Dados.anexo_base64 = NovoAnexo.base64;
                        Dados.anexo_nome = NovoAnexo.nome;
                        Dados.anexo_tipo_mime = NovoAnexo.tipo;
                    }
                    else if (RemoverAnexo) {
                        Dados.anexo_remover = true;
                    }
                    if (!(modo == MODOS.CADASTRAR)) return [3 /*break*/, 2];
                    return [4 /*yield*/, cadastrarJustificativa(Dados)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, alterarJustificativa(Dados, id !== null && id !== void 0 ? id : '')];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    Resp = _a;
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem(modo == MODOS.CADASTRAR ? MENSAGENS.REGISTRO_CADASTRADO_SUCESSO : MENSAGENS.REGISTRO_ALTERADO_SUCESSO);
                        navigate(ROUTES.GF_CONTROLE_JUSTIFICATIVAS);
                    }
                    else if (Resp) {
                        alert(Resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var editarRegistro = function () { return navigate("".concat(ROUTES.GF_CONTROLE_JUSTIFICATIVAS, "/").concat(id, "/").concat(MODOS.ALTERAR)); };
    var visualizarAnexo = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id)
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, abrirAnexoJustificativa(id)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var TituloTela = modo == MODOS.VISUALIZAR ? 'Visualizar Justificativa' : modo == MODOS.CADASTRAR ? 'Nova Justificativa' : 'Alterar Justificativa';
    var exibeAnexoExistente = !!AnexoNomeExistente && !NovoAnexo && !RemoverAnexo;
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.GF_CONTROLE_JUSTIFICATIVAS, pagina_especifica_permissao: FUNCIONALIDADES.GF_CONTROLE_JUSTIFICATIVAS, link_pagina_acima: ROUTES.GF_CONTROLE_JUSTIFICATIVAS }, { children: _jsxs(BoxPrincipal, __assign({ sx: { width: '90%' } }, { children: [!LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ sx: { mt: 2 } }, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: TituloTela })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'codigo', label: 'C\u00F3digo Justificativa', value: Codigo, onChange: function (e) { return changeCodigo(e.target.value); }, inputProps: { maxLength: 15, inputMode: 'numeric' }, required: true, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 6 }, { children: _jsx(InputDados, { id: 'nome', label: 'Nome da Justificativa', value: Nome, onChange: function (e) { return setNome(e.target.value); }, inputProps: { maxLength: 100 }, required: true, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'situacao', label: 'Situa\u00E7\u00E3o', value: Situacao, onChange: function (e) { return setSituacao(e.target.value); }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(InputDados, { id: 'descricao_resumida', label: 'Descri\u00E7\u00E3o Resumida', value: DescricaoResumida, onChange: function (e) { return setDescricaoResumida(e.target.value.substring(0, 200)); }, inputProps: { maxLength: 200 }, disabled: DESABILITAR_CAMPOS }) })), _jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' } }, { children: [_jsx(Typography, __assign({ variant: 'caption', sx: { fontWeight: 700, color: '#374151' } }, { children: "Descri\u00E7\u00E3o / Observa\u00E7\u00E3o Detalhada" })), _jsxs(Typography, __assign({ variant: 'caption', sx: { color: '#9ca3af' } }, { children: [DescricaoDetalhada.length, "/", MAX_DETALHADA] }))] })), _jsx(InputDados, { id: 'descricao_detalhada', label: '', value: DescricaoDetalhada, onChange: function (e) { return setDescricaoDetalhada(e.target.value.substring(0, MAX_DETALHADA)); }, multiline: true, rows: 4, inputProps: { maxLength: MAX_DETALHADA }, disabled: DESABILITAR_CAMPOS })] }))] })), _jsxs(Box, __assign({ sx: { mt: 3 } }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', sx: { fontWeight: 600, mb: 1 } }, { children: "Anexo Comprovante" })), exibeAnexoExistente && (_jsxs(Paper, __assign({ variant: 'outlined', sx: { p: 1.5, display: 'flex', alignItems: 'center', gap: 1.5, borderRadius: 2 } }, { children: [_jsx(PdfIcon, { sx: { color: '#dc2626' } }), _jsx(Typography, __assign({ variant: 'body2', sx: { flexGrow: 1, fontWeight: 600 } }, { children: AnexoNomeExistente })), _jsx(Button, __assign({ size: 'small', startIcon: _jsx(VisibilityIcon, {}), onClick: visualizarAnexo, sx: { textTransform: 'none' } }, { children: "Visualizar / Baixar" })), !DESABILITAR_CAMPOS && (_jsx(IconButton, __assign({ size: 'small', color: 'error', onClick: function () { return setRemoverAnexo(true); } }, { children: _jsx(DeleteIcon, { fontSize: 'small' }) })))] }))), NovoAnexo && (_jsxs(Paper, __assign({ variant: 'outlined', sx: { p: 1.5, display: 'flex', alignItems: 'center', gap: 1.5, borderRadius: 2 } }, { children: [_jsx(PdfIcon, { sx: { color: '#dc2626' } }), _jsxs(Box, __assign({ sx: { flexGrow: 1 } }, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: { fontWeight: 600 } }, { children: NovoAnexo.nome })), _jsx(Typography, __assign({ variant: 'caption', sx: { color: '#6b7280' } }, { children: NovoAnexo.tamanho }))] })), !DESABILITAR_CAMPOS && (_jsx(IconButton, __assign({ size: 'small', color: 'error', onClick: function () { return setNovoAnexo(null); } }, { children: _jsx(DeleteIcon, { fontSize: 'small' }) })))] }))), !DESABILITAR_CAMPOS && !exibeAnexoExistente && !NovoAnexo && (_jsxs(Box, __assign({ component: 'label', sx: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                p: 3,
                                                border: '2px dashed #e5e7eb',
                                                borderRadius: 2,
                                                cursor: 'pointer',
                                                '&:hover': { backgroundColor: '#f9fafb' },
                                            } }, { children: [_jsx("input", { type: 'file', hidden: true, accept: 'image/jpeg,image/png,application/pdf', onChange: function (e) {
                                                        var _a;
                                                        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                                        if (file)
                                                            processarArquivo(file);
                                                    } }), _jsx(UploadIcon, { sx: { color: '#9ca3af', mb: 1 } }), _jsx(Typography, __assign({ variant: 'body2', sx: { color: '#6b7280' } }, { children: "Clique para anexar um comprovante (PDF ou JPG, m\u00E1x. 5 MB)" }))] }))), DESABILITAR_CAMPOS && !AnexoNomeExistente && (_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#9ca3af' } }, { children: "Nenhum anexo cadastrado." })))] }))] })), _jsxs(BoxBotoes, { children: [(MODOS.ALTERAR == modo || MODOS.CADASTRAR == modo) && _jsx(BotaoSalvar, { label: 'Salvar Justificativa', onClick: salvarDados }), MODOS.VISUALIZAR == modo && _jsx(BotaoEditar, { onClick: editarRegistro, disabled: AcoesFuncionalidade['ALTERAR'] === false }), _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.GF_CONTROLE_JUSTIFICATIVAS, label: 'Voltar' })] })] })), loading && _jsx(Loading, {})] })) })));
};
export default ControleJustificativasEditar;
